function toggleMobileMenu(event) {
  const dropdown = document.querySelector(".mobile-menu-dropdown");
  dropdown.classList.toggle("active");

  if (event) {
    event.stopPropagation();
  }
}

// Close mobile menu when clicking outside
document.addEventListener("click", function (event) {
  const dropdown = document.querySelector(".mobile-menu-dropdown");
  if (!dropdown) return;

  const isClickInside =
    dropdown.contains(event.target) ||
    event.target.closest(".mobile-menu-toggle");

  if (!isClickInside && dropdown.classList.contains("active")) {
    dropdown.classList.remove("active");
  }
});

function showContent(section) {
  // Hide all topic sections first
  const allSections = document.querySelectorAll(".topic-main");
  allSections.forEach((sec) => sec.classList.add("hidden"));

  // Show the selected section
  const targetSection = document.getElementById(section + "-content");
  if (targetSection) {
    targetSection.classList.remove("hidden");
  }

  // Reset all nav links + icons
  const allLinks = document.querySelectorAll(".nav-link");
  allLinks.forEach((link) => {
    link.classList.remove("active");
    const icon = link.querySelector("img.topic-menu-icon");
    if (icon) {
      icon.classList.remove("selected-icon");
    }
  });

  // Activate current nav link + icon
  const activeLinks = document.querySelectorAll(`[data-section="${section}"]`);
  activeLinks.forEach((link) => {
    link.classList.add("active");
    const icon = link.querySelector("img.topic-menu-icon");
    if (icon) {
      icon.classList.add("selected-icon");
    }
  });

  // Update topic
  const topicTitle = document.getElementById("topic-title");
  if (topicTitle) {
    topicTitle.textContent = section;
  }

  // Update title
  const pageTitle = document.getElementById("page-title");
  if (pageTitle) {
    pageTitle.textContent = section.toUpperCase();
  }

  // Close mobile dropdown
  const dropdown = document.querySelector(".mobile-menu-dropdown");
  if (dropdown && dropdown.classList.contains("active")) {
    dropdown.classList.remove("active");
  }

  return false;
}
